import { arrayMove } from "@dnd-kit/sortable";
import { useEffect, useRef, useState } from "react";
interface IProps {
  onDragging?: (index: number, x: number) => number | undefined;
  onDragStopped: (activeIndex: number, overIndex: number) => void;
  index: number;
}

const useDrag = (props: IProps) => {
  const { onDragging, onDragStopped, index } = props;
  const eleHoldDragRef = useRef<HTMLDivElement>(null);
  const itemContainerDragRef = useRef<HTMLDivElement>(null);
  const infoDragRef = useRef({
    xStart: 0,
    overIndex: index,
  });
  const [isDragging, setIsDragging] = useState(false);
  useEffect(() => {
    const abortController = new AbortController();

    if (eleHoldDragRef.current) {
      eleHoldDragRef.current.onmousedown = (e) => {
        infoDragRef.current.xStart = e.x;
        e.stopPropagation();
        if ((e.target as HTMLElement).tagName === "INPUT") {
          setIsDragging(false);
          return;
        }
        setIsDragging(true);
      };
    }
    if (eleHoldDragRef.current && isDragging && itemContainerDragRef.current) {
      window.addEventListener(
        "mousemove",
        (e) => {
          if (!itemContainerDragRef.current) return;
          if (onDragging) {
            const x = e.x - infoDragRef.current.xStart;
            infoDragRef.current.overIndex = onDragging(index, x)!;
          }
        },
        { signal: abortController.signal },
      );

      window.addEventListener(
        "mouseup",
        (e) => {
          setIsDragging(false);
          onDragStopped(index, infoDragRef.current.overIndex);
        },
        { signal: abortController.signal },
      );
    }

    return () => abortController.abort();
  }, [
    eleHoldDragRef.current,
    isDragging,
    itemContainerDragRef.current,
    onDragStopped,
    onDragging,
    index,
  ]);

  useEffect(() => {
    infoDragRef.current.overIndex = index;
  }, [index]);
  return {
    eleHoldDragRef,
    itemContainerDragRef,
    isDragging,
  };
};

export default useDrag;
